import React, { useEffect, useState } from "react";
import "./footer.css";
import google from "../../Images/google.svg";
import apple from "../../Images/apple.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { link } from "../../config";
import axios from "axios";

function Fotter() {
  const { t } = useTranslation();
  const [webConfig, setWebConfig] = useState({});

  const getWebConfig = async () => {
    try {
      const { data } = await axios.get(`${link}web-config`);
      setWebConfig(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getWebConfig();
  }, []);
  return (
    <div className="footer w-100 d-flex justify-content-center pt-5 pb-lg-0 ">
      <div className=" fotter-div d-flex justify-content-center m-0 p-0 w-100">
        <div className="fotter-body d-flex flex-column gap-3 gap-md-1 flex-md-row w-75">
          <ul className="u-list mx-4">
            <li className="list-1">
              <Link to="/weare">{t("who are we")} </Link>
            </li>
            <li className="list-1">
              <Link to="">{t("beOurSeller")}</Link>
            </li>
            <li className="list-1">
              <Link to="/contacts">{t("contactInformation")}</Link>
            </li>
            <li className="list-1">
              <Link to="/conditions">{t("termsAndConditions")}</Link>
            </li>
            <li className="list-1">
              <Link to="/policies">{t("policies")}</Link>
            </li>
          </ul>
          <div className="fotter-subscribe">
            <p className=" text-center ">{t("subscribeToNews")}</p>
            <div className="d-flex gap-2">
              <input type="email" placeholder={t("enterYourEmail")} />
              <button>{t("subscribe")}</button>
            </div>
          </div>
          <div className="fotter-sec-div">
            <div className="fotter-sec-div1">
              <div className="w-100 fotter-sec-div2">
                {t("Shop via the app")}
              </div>
              <div className="w-100 fotter-sec-div3">
                <img src={apple} alt="app-store"></img>
                <img src={google} alt="google-play"></img>
              </div>
            </div>
            <div className="fotter-sec-div1">
              <div className="w-100 fotter-sec-div2">{t("Follow us")}</div>
              <div className="w-100 fotter-sec-div3">
                <a href={webConfig?.snapchatLink} target="_blank">
                  <svg
                    width="39"
                    height="40"
                    viewBox="0 0 39 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="19.5" cy="19.5701" r="19.5" fill="#F2DA5E" />
                    <path
                      d="M19.872 29.8346C18.6817 29.8346 17.8881 29.2728 17.1793 28.778C16.6755 28.4213 16.2029 28.0825 15.6456 27.9889C15.3737 27.9398 15.0973 27.922 14.8432 27.922C14.3706 27.922 13.9961 27.9933 13.7286 28.0468C13.5592 28.078 13.4166 28.1048 13.3051 28.1048C13.1892 28.1048 13.0421 28.0736 12.9841 27.8774C12.9351 27.7169 12.9039 27.5654 12.8727 27.4182C12.7924 27.0482 12.7255 26.8208 12.5873 26.7986C11.0983 26.5712 10.2067 26.2279 10.0328 25.8222C10.0194 25.7776 10.0016 25.733 10.0016 25.6974C9.99267 25.5726 10.0818 25.47 10.2067 25.4477C11.3881 25.2516 12.4491 24.623 13.3452 23.5887C14.0407 22.7862 14.3795 22.0105 14.4107 21.9258C14.4107 21.9168 14.4196 21.9168 14.4196 21.9168C14.5891 21.5647 14.6247 21.266 14.5222 21.0208C14.3305 20.5616 13.6974 20.3654 13.265 20.2317C13.1535 20.2004 13.0599 20.1648 12.9797 20.138C12.6096 19.9909 11.9944 19.6788 12.0746 19.2464C12.1326 18.9343 12.5472 18.7114 12.886 18.7114C12.9797 18.7114 13.0599 18.7248 13.1268 18.7605C13.5057 18.9343 13.849 19.0235 14.1432 19.0235C14.5088 19.0235 14.6827 18.8853 14.7273 18.8407C14.7183 18.6445 14.705 18.4395 14.6916 18.2478C14.6024 16.8835 14.4999 15.1894 14.9323 14.2175C16.2297 11.3108 18.9848 11.079 19.8007 11.079C19.823 11.079 20.1573 11.0701 20.1573 11.0701C20.1707 11.0701 20.1885 11.0701 20.2064 11.0701C21.0222 11.0701 23.7774 11.2974 25.0747 14.2086C25.5116 15.1805 25.4046 16.8791 25.3154 18.2388L25.3065 18.3057C25.2976 18.4885 25.2842 18.6624 25.2753 18.8407C25.3199 18.8764 25.4804 19.0101 25.8103 19.0146C26.0956 19.0057 26.4077 18.912 26.7643 18.7515C26.8758 18.7025 26.9917 18.6847 27.0764 18.6847C27.2012 18.6847 27.3261 18.7159 27.4331 18.7515H27.442C27.7407 18.863 27.9368 19.0725 27.9368 19.291C27.9458 19.4961 27.7853 19.8081 27.0229 20.1157C26.9427 20.1469 26.849 20.1826 26.7376 20.2094C26.3141 20.3387 25.681 20.5437 25.4804 20.9985C25.3689 21.2392 25.4135 21.5468 25.5829 21.8946C25.5829 21.9035 25.5918 21.9035 25.5918 21.9035C25.6409 22.0283 26.9293 24.9529 29.7959 25.4299C29.9207 25.4522 30.001 25.5547 30.001 25.6795C30.001 25.7241 29.9921 25.7687 29.9698 25.8088C29.7959 26.219 28.9132 26.5534 27.4152 26.7852C27.277 26.8075 27.2102 27.0348 27.1299 27.4049C27.0987 27.5564 27.063 27.7036 27.0185 27.8641C26.9739 28.0112 26.8803 28.0914 26.7198 28.0914H26.6975C26.5949 28.0914 26.4567 28.078 26.2739 28.0424C25.953 27.9755 25.6008 27.9265 25.1594 27.9265C24.8964 27.9265 24.6244 27.9488 24.3569 27.9933C23.8041 28.0825 23.3271 28.4258 22.8233 28.7824C22.1055 29.2728 21.3075 29.8346 20.1261 29.8346C20.1261 29.8346 19.9077 29.8346 19.872 29.8346Z"
                      fill="#292D32"
                    />
                  </svg>
                </a>
                <a href={webConfig?.youtubeLink} target="_blank">
                  <svg
                    width="39"
                    height="40"
                    viewBox="0 0 39 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="19.5" cy="19.5701" r="19.5" fill="#F2DA5E" />
                    <path
                      d="M20.2439 12.0701C20.778 12.073 22.1143 12.0859 23.5341 12.1428L24.0375 12.1647C25.467 12.2324 26.8953 12.348 27.6037 12.5456C28.5486 12.811 29.2913 13.5856 29.5423 14.5674C29.942 16.1265 29.992 19.1695 29.9982 19.9059L29.9991 20.0585V20.0692C29.9991 20.0692 29.9991 20.0729 29.9991 20.08L29.9982 20.2326C29.992 20.969 29.942 24.012 29.5423 25.5711C29.2878 26.5565 28.5451 27.3311 27.6037 27.5929C26.8953 27.7904 25.467 27.906 24.0375 27.9737L23.5341 27.9956C22.1143 28.0525 20.778 28.0654 20.2439 28.0684L20.0095 28.0692H19.9991C19.9991 28.0692 19.9956 28.0692 19.9887 28.0692L19.7545 28.0684C18.6241 28.0622 13.8977 28.0111 12.3945 27.5929C11.4496 27.3274 10.7069 26.5529 10.4559 25.5711C10.0562 24.012 10.0062 20.969 10 20.2326V19.9059C10.0062 19.1695 10.0562 16.1265 10.4559 14.5674C10.7104 13.5819 11.4531 12.8074 12.3945 12.5456C13.8977 12.1273 18.6241 12.0763 19.7545 12.0701H20.2439ZM17.9991 16.5692V23.5692L23.9991 20.0692L17.9991 16.5692Z"
                      fill="#292D32"
                    />
                  </svg>
                </a>
                <a href={webConfig?.instagramLink} target="_blank">
                  <svg
                    width="39"
                    height="40"
                    viewBox="0 0 39 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="19.5" cy="19.5701" r="19.5" fill="#F2DA5E" />
                    <path
                      d="M21.0271 10.0701C22.1525 10.0719 22.7228 10.0779 23.2156 10.0925L23.4097 10.0989C23.6339 10.1069 23.8551 10.1169 24.1218 10.1294C25.1859 10.1785 25.9118 10.3469 26.5493 10.5944C27.2084 10.8485 27.7651 11.1919 28.3209 11.7477C28.8759 12.3035 29.2193 12.8619 29.4743 13.5194C29.7209 14.156 29.8893 14.8827 29.9393 15.9469C29.9512 16.2135 29.9608 16.4347 29.9687 16.659L29.975 16.8531C29.9896 17.3458 29.9963 17.9162 29.9984 19.0416L29.9992 19.7873C29.9993 19.8784 29.9993 19.9724 29.9993 20.0694L29.9992 20.3515L29.9986 21.0972C29.9967 22.2226 29.9908 22.7929 29.9761 23.2857L29.9697 23.4798C29.9618 23.704 29.9518 23.9252 29.9393 24.1919C29.8901 25.256 29.7209 25.9819 29.4743 26.6194C29.2201 27.2785 28.8759 27.8352 28.3209 28.391C27.7651 28.946 27.2059 29.2894 26.5493 29.5444C25.9118 29.791 25.1859 29.9594 24.1218 30.0094C23.8551 30.0213 23.6339 30.0309 23.4097 30.0388L23.2156 30.0451C22.7228 30.0597 22.1525 30.0664 21.0271 30.0685L20.2814 30.0693C20.1903 30.0694 20.0963 30.0694 19.9993 30.0694L19.7172 30.0693L18.9715 30.0687C17.8461 30.0668 17.2757 30.0609 16.783 30.0462L16.5889 30.0398C16.3647 30.0319 16.1435 30.0219 15.8768 30.0094C14.8126 29.9602 14.0876 29.791 13.4493 29.5444C12.791 29.2902 12.2335 28.946 11.6776 28.391C11.1218 27.8352 10.7793 27.276 10.5243 26.6194C10.2768 25.9819 10.1093 25.256 10.0593 24.1919C10.0474 23.9252 10.0377 23.704 10.0299 23.4798L10.0236 23.2857C10.009 22.7929 10.0023 22.2226 10.0001 21.0972L10 19.0416C10.0019 17.9162 10.0078 17.3458 10.0225 16.8531L10.0288 16.659C10.0368 16.4347 10.0468 16.2135 10.0593 15.9469C10.1085 14.8819 10.2768 14.1569 10.5243 13.5194C10.7785 12.861 11.1218 12.3035 11.6776 11.7477C12.2335 11.1919 12.7918 10.8494 13.4493 10.5944C14.0868 10.3469 14.8118 10.1794 15.8768 10.1294C16.1435 10.1175 16.3647 10.1078 16.5889 10.0999L16.783 10.0937C17.2757 10.079 17.8461 10.0724 18.9715 10.0702L21.0271 10.0701ZM19.9993 15.0694C17.2364 15.0694 14.9993 17.3089 14.9993 20.0694C14.9993 22.8323 17.2388 25.0694 19.9993 25.0694C22.7622 25.0694 24.9993 22.8298 24.9993 20.0694C24.9993 17.3065 22.7597 15.0694 19.9993 15.0694ZM19.9993 17.0694C21.6562 17.0694 22.9993 18.412 22.9993 20.0694C22.9993 21.7263 21.6566 23.0694 19.9993 23.0694C18.3424 23.0694 16.9993 21.7267 16.9993 20.0694C16.9993 18.4125 18.3419 17.0694 19.9993 17.0694ZM25.2493 13.5694C24.56 13.5694 23.9993 14.1293 23.9993 14.8185C23.9993 15.5078 24.5592 16.0685 25.2493 16.0685C25.9385 16.0685 26.4993 15.5086 26.4993 14.8185C26.4993 14.1293 25.9376 13.5685 25.2493 13.5694Z"
                      fill="#292D32"
                    />
                  </svg>
                </a>
                <a href={webConfig?.linkedinLink} target="_blank">
                  <svg
                    width="39"
                    height="40"
                    viewBox="0 0 39 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="19.5" cy="19.5701" r="19.5" fill="#F2DA5E" />
                    <path
                      d="M14.9405 13.07C14.9401 13.8843 14.4461 14.6171 13.6913 14.9228C12.9366 15.2285 12.0719 15.0461 11.5049 14.4616C10.9379 13.8771 10.7819 13.0072 11.1105 12.2621C11.4391 11.5171 12.1865 11.0456 13.0005 11.07C14.0815 11.1024 14.941 11.9884 14.9405 13.07ZM15.0005 16.55H11.0005V29.07H15.0005V16.55ZM21.3205 16.55H17.3405V29.07H21.2805V22.5C21.2805 18.84 26.0505 18.5 26.0505 22.5V29.07H30.0005V21.14C30.0005 14.97 22.9405 15.2 21.2805 18.23L21.3205 16.55Z"
                      fill="#292D32"
                    />
                  </svg>
                </a>
                <a href={webConfig?.twitterLink} target="_blank">
                  <svg
                    width="39"
                    height="40"
                    viewBox="0 0 39 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="19.5" cy="19.5701" r="19.5" fill="#F2DA5E" />
                    <path
                      d="M30.2125 13.7261C29.4491 14.0638 28.6395 14.2856 27.8106 14.3842C28.6839 13.8614 29.3374 13.039 29.6493 12.0701C28.8287 12.5577 27.9305 12.9008 26.9938 13.0847C26.2031 12.2411 25.098 11.7631 23.9418 11.7644C21.6326 11.7644 19.7597 13.6367 19.7597 15.9469C19.7597 16.2746 19.7973 16.5925 19.8676 16.8992C16.3905 16.7241 13.3101 15.0601 11.2468 12.5295C10.8753 13.1677 10.6801 13.8932 10.681 14.6317C10.681 16.0827 11.4196 17.3633 12.5415 18.1131C11.8774 18.0921 11.2279 17.9127 10.6472 17.5898C10.6465 17.6074 10.6465 17.6249 10.6465 17.6415C10.6465 19.6685 12.0882 21.3593 14.002 21.7432C13.6428 21.8404 13.2723 21.8895 12.9002 21.8892C12.63 21.8892 12.3677 21.8643 12.1128 21.8154C12.6453 23.4766 14.1889 24.686 16.0196 24.7192C14.5381 25.8819 12.7087 26.5127 10.8254 26.51C10.4921 26.5103 10.1591 26.4906 9.82812 26.4512C11.74 27.6803 13.9655 28.3326 16.2384 28.3302C23.9316 28.3302 28.138 21.9576 28.138 16.4312C28.138 16.2504 28.1336 16.0689 28.1256 15.89C28.9443 15.2985 29.651 14.5657 30.2125 13.7261Z"
                      fill="#292D32"
                    />
                  </svg>
                </a>
                <a href={webConfig?.facebookLink} target="_blank">
                  <svg
                    width="39"
                    height="40"
                    viewBox="0 0 39 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="19.5" cy="19.5701" r="19.5" fill="#F2DA5E" />
                    <g clip-path="url(#clip0_2_111)">
                      <path
                        d="M22 21.5701H24.5L25.5 17.5701H22V15.5701C22 14.5407 22 13.5701 24 13.5701H25.5V10.2102C25.1743 10.1669 23.943 10.0701 22.6429 10.0701C19.9284 10.0701 18 11.7269 18 14.7698V17.5701H15V21.5701H18V30.0701H22V21.5701Z"
                        fill="#292D32"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2_111">
                        <rect
                          width="24"
                          height="24"
                          fill="white"
                          transform="translate(8 8.07007)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="foot-foot w-100  p-0 ">{t("foot")}</div>
      </div>
    </div>
  );
}
export default Fotter;
